import {Component, EventEmitter, Input, OnInit, OnDestroy, Output} from '@angular/core';
import {AreasDestinoService} from "../../../services/areas-destino.service";
import {NotificationService} from "../../../services/notification.service";
import {NgForm} from "@angular/forms";
import {ConstantsService} from '../../../fidelidade/ConstantsService';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-cad-area-destino',
  templateUrl: './cad-area-destino.component.html',
  styleUrls: ['./cad-area-destino.component.scss']
})
export class CadAreaDestinoComponent implements OnInit, OnDestroy {
  @Input() area: any = { etapas: [], etapasRemovidas: [] };
  @Output() salvo = new EventEmitter<any>();
  @Output() cancelado = new EventEmitter<any>();

  temEtapas = false;
  salvando = false;
  mensagemErro: string;
  categoriasDisponiveis: any[] = [];
  comissionados: any[] = [];
  comissionadoId: number = null;
  moduloComissionamentoAtivo = false;
  labelComissionado = 'Comissionado';
  private empresaSubscription: Subscription;
  // EnumStatusPedido - assumindo valores comuns ou pegando do backend se necessário.
  // Vou deixar simples por enquanto ou usar um hardcoded se não tiver o enum no front
  listaStatus = [
   // { text: 'Novo', value: 0 },
    { text: 'Em Preparação', value: 1 },
  //  { text: 'Pronto', value: 2 },
    // Adicionar outros conforme necessidade do sistema
  ];

  constructor(private service: AreasDestinoService,
              private notification: NotificationService, private constants: ConstantsService) { }

  ngOnInit(): void {
    this.service.listeCategorias().then((res: any) => this.categoriasDisponiveis = res);
    this.empresaSubscription = this.constants.empresa$.subscribe(empresa => {
      if(!empresa) return;
      this.moduloComissionamentoAtivo = this.constants.possuiModulo(empresa, 'comissionamento') && this.constants.possuiRecurso(empresa, 'estoque') &&
        (empresa.producaoPedidosAtiva === true || Number(empresa.producaoPedidosAtiva) === 1);
      const nome = String(empresa.comissionadoLabel || 'Comissionado').trim();
      this.labelComissionado = nome.toLowerCase().endsWith('s') ? nome.slice(0, -1) : nome;
      if(this.moduloComissionamentoAtivo)
        this.service.listeComissionados().then((res: any) => this.comissionados = res)
          .catch(erro => this.mensagemErro = 'Erro ao carregar comissionados: ' + (erro.message || erro));
    });

    if (!this.area)
      this.area = { etapas: [], envioAutomatico: false, statusPedido: this.listaStatus[0] };

    if (!this.area.etapas)
      this.area.etapas = [];

    if (!this.area.categorias)
      this.area.categorias = [];

    this.temEtapas = this.area.etapas.length > 0;
    this.comissionadoId = this.area.comissionado?.id || null;
    if(this.area.statusPedido == null) this.area.statusPedido = 1;
  }

  alterouComissionado() {
    this.area.comissionado = this.comissionadoId ? {id: this.comissionadoId} : null;
    if(this.comissionadoId) {
      this.area.envioAutomatico = false;
      this.area.categorias = [];
      this.area.statusPedido = 1;
    }
  }

  onTemEtapasChange(checked: boolean) {
    this.temEtapas = checked;
    if (checked && this.area.etapas.length === 0) {
      this.addEtapa();
      this.addEtapa();
    }
  }

  addEtapa() {
    this.area.etapas.push({ nome: '', ordem: this.area.etapas.length + 1 , $id: new Date().getTime()});
  }

  removeEtapa(index: number, etapa: any) {
    this.area.etapas.splice(index, 1);

    if(!this.area.etapasRemovidas) this.area.etapasRemovidas = []

    this.area.etapasRemovidas.push(etapa)
  }

  sobeEtapa(index: number) {
    if (index > 0) {
      const temp = this.area.etapas[index];
      this.area.etapas[index] = this.area.etapas[index - 1];
      this.area.etapas[index - 1] = temp;
    }
  }

  desceEtapa(index: number) {
    if (index < this.area.etapas.length - 1) {
      const temp = this.area.etapas[index];
      this.area.etapas[index] = this.area.etapas[index + 1];
      this.area.etapas[index + 1] = temp;
    }
  }

  validar(frm: NgForm): boolean {
    this.mensagemErro = null;

    if(!frm.valid){
      this.mensagemErro = 'Verifique os campos obrigatórios'
      return false;
    }


    if (this.temEtapas) {
      for (let etapa of this.area.etapas) {
        if (!etapa.nome) {
          this.mensagemErro = "Todas as etapas devem ter nome.";
          return false;
        }
      }
    } else {
        // Se desmarcou, limpa as etapas para salvar
        this.area.etapas = [];
    }

    return true;
  }

  salvar(frm: any) {
    if (!this.validar(frm)) return;

    this.salvando = true;
    this.service.salveArea(this.area).then(() => {
      this.salvando = false;
      this.salvo.emit(this.area);
      setTimeout(() => {
        this.notification.showSuccess("Área salva com sucesso!");
      }, 300)
    }).catch(err => {
      this.salvando = false;
      this.mensagemErro = "Erro ao salvar: " + (err.error?.message || err.message || err);
    });
  }

  cancelar() {
    this.cancelado.emit();
  }

  ngOnDestroy() {
    this.empresaSubscription?.unsubscribe();
  }
}
